<bizz-modal title="PermissionHistory" [contentTemplate]="contentTemplateRef"></bizz-modal>

<ng-template #contentTemplateRef>
    <div class="modal-content">
        <bizz-permission-history-grid [foreignId]="data.auditLogItem.AuditLogsID" [itemType]="itemType"></bizz-permission-history-grid>
    </div>
</ng-template>